// extracted by mini-css-extract-plugin
export default {"container":"style_container__btCj9","content":"style_content__5BuiK","title":"style_title__8Dj2o","title_header":"style_title_header__R+Orx","title_inner":"style_title_inner__hfR5R"};